import Layout from "./layout";

import "./header.scss";
import Footer from "../footer";

import { global } from "utils/pageConstants";
import { useMemo } from "react";

import Seo from "@/components/elements/seo";

export function RefreshHeader({ children, metadata }) {
  const { footer } = useMemo(() => global().attributes, []);

  const metadataWithDefaults = {
    ...global().attributes.metadata,
    ...metadata,
  };
  return (
    <Layout>
      <Seo metadata={metadataWithDefaults} />
      <div className="block">
        <div className="parallax-container">
          <p className="text-size-6 4xl:text-size-10 md:text-size-8 text-white text-center w-11/12 md:w-3/4 mx-auto font-ppNeue break-words pt-spacing-14">
            {metadata?.metaTitle}
          </p>
        </div>
        <div className="main-container font-euclid">
          <div className="px-spacing-7 pt-spacing-12 pb-[104px] lg:pt-spacing-14 lg:pb-36 lg:px-0 lg:max-w-spacing-920 mx-auto">
            {children}
          </div>
          <Footer footer={footer} />
        </div>
      </div>
    </Layout>
  );
}
